<style lang="less">
  // @import '../flow.less';
  @import '../flow/base.less';
</style>
<template>
    <div class="demo-split webTerminal tree-style">
      <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <div>
          <Row class="theme-two-bg" :style="{backgroundColor: '#fff', padding: '1px', borderRadius: '3px'}">
            <Col span="24" v-bind:md="serverGroupSpan">
              <!-- <Button @click="ServerGroupShowBtn(false)" v-show="ServerGroupIsShow" type="primary" size="small" :style="{float: 'right'}">
                <Icon type="ios-arrow-back" />
              </Button>
              <Button @click="ServerGroupShowBtn(true)" v-show="!ServerGroupIsShow" type="primary" size="small" :style="{float: 'right'}">
                <Icon type="ios-arrow-forward" />
              </Button> -->
              <ul v-show="ServerGroupIsShow" id="serverGroupZTree" class="ztree"></ul>
            </Col>
            <div id="rMenu" style="z-index: 1999;">
              <a href="#" class="list-group-item" @click="handleConnect">连接</a>
              <a href="#" class="list-group-item" @click="handleDisconnect">断开</a>
              <!-- <a href="#" class="list-group-item" @click="expand">展开下一级</a>
              <a href="#" class="list-group-item" @click="expandSon">展开所有子节点</a>
              <a href="#" class="list-group-item" @click="collapse">折叠子节点</a>
              <a href="#" class="list-group-item" @click="openAll">全部展开</a>
              <a href="#" class="list-group-item" @click="collapseAll">全部折叠</a> -->
            </div>

          </Row>
        </div>
      </div>
      <div slot="right" class="demo-split-pane">
        <!-- <Tabs type="card" closable v-model="currentTab" @on-click="handleTabClick" @on-tab-remove="handleTabRemove" capture-focus>
        <TabPane v-for="item in tabs" :key="item.tabname" :label="item.name" :name="item.tabname" v-if="item.display">
          <TabTerminal  :url="item.url"/> -->
          <!-- <iframe :src="item.url" style="width:100%;min-height:760px;over-flow:hidden"></iframe> -->
          <!-- <GuacClient :connectionID="newId" /> -->
        <!-- </TabPane>
      </Tabs> -->
      <Alert type="success" v-show="isAlertShow">
          {{ alertHostName }}
          <template slot="desc">内网IP：{{ alertInnerIp }} , 外网IP：{{ alertPublicIp }}, 操作系统：{{ alertOs === '0' ? 'Linux' : alertOs === '1' ? 'Windows' : '' }}</template>
      </Alert>
      </div>
    </Split>
  </div>
</template>
<script>
// import { getProjectDetail, ProjectBaseInfoSubmit } from '@/api/project'
import { getOpsCenterServerGroupHostMine, changeOpsCenterServerGroup, deleteOpsCenterServerGroup,
  getOpsCenterAllSupport, changeOpsCenterServer, getOpsCenterServer, getOpsCenterAllServer,
  getOpsCenterAllCertificate, getRegion, collectServer, getUserHostPerm, getConnectId, getGuacamoleToken } from '@/api/opscenter'

// import { getGuacamoleToken } from '@/api/springboard'
import { ClientIdentifier } from '@/libs/clientIdentifier'
import config from '@/config'
import { getBaseMonitorOne } from '@/api/monitor'
import TabTerminal from './TabTerminal'
// import GuacClient from 'vue-guacamole-client'

const guacamoleUrl = config.guacamoleUrl
export default {
  name: 'WebTerminal',
  components: {
    TabTerminal
  },
  data () {
    return {
      alertHostName: '',
      alertInnerIp: '',
      alertPublicIp: '',
      alertOs: '',
      isAlertShow: false,
      guacamoleToken: '',
      connectionIDs: [],
      newId: null,
      currentTab: 'tab0',
      url: null,
      tabs: [],
      data: {},
      split1: 0.15,
      ServerGroupIsShow: true,
      serverGroupSpan: 4,
      serverTableSpan: 20,
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      searchForm: {
        id__in: '',
        hostname: '',
        server_id: '',
        name: '',
        inner_ip: '',
        public_ip: '',
        support: '',
        region: '',
        os: '',
        server_info: ''
      },
      count: 1,
      page: 1,
      size: 13,
      selectRow: '',
      systemUsersAll: [],
      systemUsersSel: '',
      systemUserKeySel: '',
      conProtocolType: '',
      conHostOs: '',
      userPermDetail: [],
      defaultIp: 'public',
      defaultSelIp: null,
      columns: [
        {
          title: '选中',
          align: 'center',
          width: 60,
          key: 'checkBox',
          render: (h, params) => {
            return h('div', [
              h('Checkbox', {
                props: {
                  value: params.row.checkBox
                },
                on: {
                  'on-change': (e) => {
                    this.tableData.forEach((items) => {
                      this.$set(items, 'checkBox', false)
                    })
                    this.tableData[params.index].checkBox = e
                  }
                }
              })
            ])
          }
        },
        {
          width: 150,
          title: '主机名',
          tooltip: true,
          key: 'hostname',
          align: 'center',
          render: (h, params) => {
            let hostname = params.row.hostname
            if (!hostname) {
              hostname = '未识别'
            }
            return h('router-link', {
              props: {
                to: '/ops_center/server_manage/' + selectNodes[0].host_id
              }
            }, hostname)
          }
        },
        {
          width: 120,
          title: '主机ID',
          tooltip: true,
          align: 'center',
          key: 'server_id'
        },
        {
          width: 120,
          title: '别名',
          tooltip: true,
          align: 'center',
          key: 'name'
        },
        {
          width: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          width: 120,
          title: '状态',
          align: 'center',
          key: 'status',
          render: (h, params) => {
            const row = params.row
            const color = row.status === 0 ? 'error' : row.status === 1 ? 'success' : 'warning'
            const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'

            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          width: 130,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        },
        {
          width: 130,
          title: '公网IP',
          align: 'center',
          key: 'public_ip'
        },
        {
          width: 100,
          title: '到期时间',
          align: 'center',
          key: '',
          render: (h, params) => {
            let color = 'green'
            if (params.row.server_info_format) {
              if (params.row.server_info_format['到期时间']) {
                let lastTime = this.daysBetween(params.row.server_info_format['到期时间'], 'now')
                if (lastTime <= 7) {
                  color = 'red'
                }
                return h('span', { style: { color: color } }, params.row.server_info_format['到期时间'])
              } else {
                return h('span', { style: { color: '#999' } }, '无')
              }
            } else {
              return h('span', { style: { color: '#999' } }, '无')
            }
          }
        },
        {
          width: 100,
          title: 'CPU使用率',
          align: 'center',
          key: 'cpu_usage',
          render: (h, params) => {
            if (params.row.cpu_usage || params.row.cpu_usage === 0) {
              let tagType = 'success'
              if (params.row.cpu_usage > 90) {
                tagType = 'error'
              } else if (params.row.cpu_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.cpu_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        {
          width: 100,
          title: '内存使用率',
          align: 'center',
          key: 'memory_usage',
          render: (h, params) => {
            if (params.row.memory_usage || params.row.memory_usage === 0) {
              let tagType = 'success'
              if (params.row.memory_usage > 90) {
                tagType = 'error'
              } else if (params.row.memory_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.memory_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        {
          width: 100,
          title: '磁盘使用率',
          align: 'center',
          key: 'disk_usage',
          render: (h, params) => {
            if (params.row.disk_usage || params.row.disk_usage === 0) {
              let tagType = 'success'
              if (params.row.disk_usage > 90) {
                tagType = 'error'
              } else if (params.row.disk_usage > 70) {
                tagType = 'warning'
              }
              return h('div', {
                class: 'ivu-tag ivu-tag-' + tagType + ' ivu-tag-checked'
              }, params.row.disk_usage)
            } else {
              return h('div', {
                style: {
                  color: '#999'
                }
              }, '无数据')
            }
          }
        },
        {
          width: 160,
          title: '服务商',
          align: 'center',
          tooltip: true,
          key: 'support_name'
        },
        {
          width: 100,
          title: '管理员',
          align: 'center',
          key: 'manager'
        },
        {
          width: 100,
          title: '凭证',
          align: 'center',
          key: 'certificate',
          render: (h, params) => {
            if (params.row.certificate) {
              // 取凭证数组里面 is_admin 是true的名字
              let cerAdmin = params.row.certificate.filter(item => item.is_admin === true)
              if (cerAdmin.length > 0) {
                return h('div', cerAdmin[0].name)
              }
            } else {
              return ''
            }
          }
        },
        {
          width: 100,
          title: '操作',
          align: 'center',
          key: '',
          // fixed: "right",
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  ghost: true
                },
                on: {
                  click: () => {
                    this.handleConnect()
                  }
                }
              }, [
                h('Icon', {
                  props: {
                    type: 'ios-desktop',
                    size: 18,
                    color: '#000000'
                  }
                })
              ])
            ])
          }
        }
      ],
      tableData: [],
      table_loading: false,
      newCount: 1,
      zTreeSetting: {
        view: {
          addHoverDom: this.addHoverDom,
          removeHoverDom: this.removeHoverDom,
          selectedMulti: false
        },
        edit: {
          enable: false,
          editNameSelectAll: false,
          showRemoveBtn: false,
          showRenameBtn: false,
          showAddBtn: false
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          // onRightClick: this.OnRightClick,
          beforeDrag: this.beforeDrag,
          beforeRemove: this.beforeRemove,
          beforeRename: this.beforeRename,
          onRemove: this.onRemove,
          onRename: this.onRename,
          onDblClick: this.onDblClick
        }
      },
      zTree: '',
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }],
      editServerModal: false,
      editServerModalTitle: '连接',
      no_select_server: [],
      editServerForm: {
        id: 0,
        name: '',
        server: [],
        parent_id: 0
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      serverChangeModal: false,
      serverForm: {
        id: 0,
        hostname: '',
        server_id: '',
        name: '',
        inner_ip: '',
        public_ip: '',
        os: 0,
        support: '',
        region: '',
        certificate: [],
        manager: '',
        server_info: '',
        remark: ''
      },
      serverFormRule: {
        hostname: [
          { required: true, message: '主机名不能为空', trigger: 'blur' }
        ],
        server_id: [
          { required: true, message: '实例ID不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '实例名称不能为空', trigger: 'blur' }
        ]
      },
      serverChangeModalTitle: '添加主机',
      allSupportList: [],
      allCertificateList: [],
      collectForm: {
        support: '',
        region: ''
      },
      collectRule: {
        support: [
          { require: true, message: '服务商不能为空', trigger: 'blur' }
        ]
      },
      collectServerLoading: false,
      allRegionList: [],
      regionList: [],
      collectModal: false
    }
  },
  watch: {
    '$route' (to, from) {
      console('进来了')
      // 对路由变化作出响应...
      // this.getServerGroup()
      // if (this.$route.query.index) {
      //   if (this.$route.query.index === 3) {
      //     // this.defaultIndex = 'TabPane1'
      //     // let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
      //     // zTree.refresh()
      //     // this.zTreeInit()
      //     this.getServerGroup()
      //   }
      // }
    }
  },
  methods: {
    getGuacamoleToken () {
      getGuacamoleToken().then(res => {
        this.guacamoleToken = res.data
      })
    },
    addConnectionId () {
      this.connectionIDs.push(this.newId)
      this.newId = null
    },
    removeId (index) {
      this.connectionIDs.splice(index, 1)
    },
    handleDisconnect () {
      let selectNodes = this.zTree.getSelectedNodes()
      // console.log(selectNodes)
      this.tabs = this.tabs.filter(item => item.hostname !== selectNodes[0].name)
    },
    handleTabRemove (name) {
      // let indexT
      this.tabs.forEach((item, index) => {
        if (item['tabname'] === name) {
          // indexT = index
          item['display'] = false
        }
      })
      // 找到index 并将tabs里的内容删除, 不用删除，删除后 ，新增的tabname 可能和 key 对不上，带来其他隐患
      // console.log(this.tabs)
      // console.log(indexT)
      // this.tabs.splice(indexT, 1)
      // console.log(this.tabs)
    },
    handleTabClick (value) {
      // console.log(value)
      this.currentTab = value.toString()
    },
    ServerGroupShowBtn (status) {
      this.ServerGroupIsShow = status
      if (status) {
        this.serverGroupSpan = 4
        this.serverTableSpan = 20
      } else {
        this.serverGroupSpan = 1
        this.serverTableSpan = 23
      }
    },
    getServers (value = 1) {
      this.page = value
      this.table_loading = true
      this.searchForm['size'] = this.size
      this.searchForm['page'] = this.page
      getOpsCenterServer(this.searchForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.count = result.count
        let hostnames = []
        for (let i in result.results) {
          if (result.results[i].hostname) {
            hostnames.push(result.results[i].hostname)
          }
        }
        let reqParams = {
          'hostnames': hostnames,
          'counters': ['mem.memused.percent', 'cpu.user', 'df.statistics.used.percent', 'agent.alive']
        }
        getBaseMonitorOne(reqParams).then(monitorRes => {
          let MonitorDataResult = monitorRes.data
          if (MonitorDataResult.code === 200) {
            for (let l in tableData) {
              let hostname = tableData[l].hostname
              let cpuUsage = ''
              let memoryUsage = ''
              let diskUsage = ''
              let agentAlive = 0
              let timestamp = ''
              if (hostname) {
                if (MonitorDataResult.data[hostname]['timestamp']) {
                  cpuUsage = MonitorDataResult.data[hostname]['cpu.user']
                  memoryUsage = MonitorDataResult.data[hostname]['mem.memused.percent']
                  diskUsage = MonitorDataResult.data[hostname]['df.statistics.used.percent']
                  agentAlive = MonitorDataResult.data[hostname]['agent.alive']
                  timestamp = MonitorDataResult.data[hostname]['timestamp']
                }
              }
              tableData[l]['status'] = agentAlive
              tableData[l]['cpu_usage'] = cpuUsage
              tableData[l]['memory_usage'] = memoryUsage
              tableData[l]['disk_usage'] = diskUsage
              tableData[l]['timestamp'] = timestamp
            }
          } else {
            this.$Notice.error({
              title: '获取监控数据失败！',
              desc: MonitorDataResult.msg
            })
          }
          this.tableData = tableData
          this.table_loading = false
        }).catch(res => {
          this.tableData = tableData
          this.table_loading = false
          if (res.request) {
            this.$Notice.error({
              title: '获取监控数据失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      }).catch(res => {
        this.table_loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getAllServers () {
      getOpsCenterAllServer().then(res => {
        let result = res.data
        this.no_select_server = []
        for (let i in result) {
          this.no_select_server.push({
            key: result[i].id,
            label: result[i].hostname
          })
        }
      })
    },
    getServerGroup () {
      // this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
      getOpsCenterServerGroupHostMine().then(res => {
        let zNodesAll = [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
        this.zNodes = zNodesAll.concat(res.data)
        // this.zNodes = this.zNodes.concat(res.data)
        this.zTreeInit()
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取主机组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    changeServerSubmit () {
      this.$refs['serverForm'].validate((valid) => {
        if (valid) {
          let regxp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
          if (this.serverForm.inner_ip) {
            if (!regxp.test(this.serverForm.inner_ip)) {
              this.$Notice.error({ title: '私有ip地址格式错误' })
              return false
            }
          }
          if (this.serverForm.public_ip) {
            if (!regxp.test(this.serverForm.public_ip)) {
              this.$Notice.error({ title: '公网ip地址格式错误' })
              return false
            }
          }
          changeOpsCenterServer(this.serverForm, this.serverForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功'
            })
            this.serverChangeModalClose()
            this.getServers()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getAllSupport () {
      getOpsCenterAllSupport().then(res => {
        this.allSupportList = res.data
      })
    },
    getAllCertificate () {
      getOpsCenterAllCertificate().then(res => {
        this.allCertificateList = res.data
      })
    },
    searchReset () {
      this.searchForm.hostname = ''
      this.searchForm.server_id = ''
      this.searchForm.name = ''
      this.searchForm.inner_ip = ''
      this.searchForm.public_ip = ''
      this.searchForm.support = ''
      this.searchForm.region = ''
      this.searchForm.os = ''
      this.searchForm.server_info = ''
    },
    changeFormReset () {
      this.serverForm.id = 0
      this.serverForm.hostname = ''
      this.serverForm.server_id = ''
      this.serverForm.name = ''
      this.serverForm.inner_ip = ''
      this.serverForm.public_ip = ''
      this.serverForm.support = ''
      this.serverForm.region = ''
      this.serverForm.os = 0
      this.serverForm.certificate = []
      this.serverForm.server_info = ''
      this.serverForm.manager = ''
      this.serverForm.remark = ''
    },
    zTreeInit () {
      this.zTree = $.fn.zTree.init($('#serverGroupZTree'), this.zTreeSetting, this.zNodes)
    },
    zTreeOnClick (event, treeId, treeNode) {
      if (treeNode.id === 0) {
        this.searchForm.id__in = ''
      } else {
        let childNodes = this.getChildNodes(treeNode)
        if (childNodes) {
          this.searchForm.id__in = childNodes
        } else {
          this.searchForm.id__in = 99999999
        }
      }
      this.getServers()
    },
    getChildNodes (treeNode) {
      let childNodes = this.zTree.transformToArray(treeNode)
      let nodes = []
      for (let i = 0; i < childNodes.length; i++) {
        if (childNodes[i].server) {
          nodes = nodes.concat(childNodes[i].server.split(','))
        }
      }
      return nodes.join(',')
    },
    OnRightClick (event, treeId, treeNode) {
      if (!treeNode && event.target.tagName.toLowerCase() !== 'button' && $(event.target).parents('a').length === 0) {
        this.zTree.cancelSelectedNode()
        this.showRMenu('root', event.clientX, event.clientY)
      } else if (treeNode && !treeNode.noR) {
        this.zTree.selectNode(treeNode)
        this.showRMenu('node', event.clientX, event.clientY)
      }
    },
    onDblClick (event, treeId, treeNode) {
      if (!treeNode['isParent'] && ((treeNode['inner_ip'] && treeNode['inner_ip'].length !== 0) || (treeNode['public_ip'] && treeNode['public_ip'].length !== 0))) {
        this.handleConnect()
      }
    },
    showRMenu (type, x, y) {
      $('#rMenu ul').show()
      $('#rMenu').css({ 'top': y - 150 + 'px', 'left': x - 300 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      if ($('#rMenu')) $('#rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#rMenu').length > 0)) {
        $('#rMenu').css({ 'visibility': 'hidden' })
      }
    },
    expand () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, null, null)
    },
    expandSon () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], true, true, null)
    },
    collapse () {
      this.hideRMenu()
      let selectNodes = this.zTree.getSelectedNodes()
      this.zTree.expandNode(selectNodes[0], false, null, null)
    },
    collapseAll () {
      this.hideRMenu()
      this.zTree.expandAll(false)
    },
    openAll () {
      this.hideRMenu()
      this.zTree.expandAll(true)
    },
    addHoverDom (treeId, treeNode) {
      if (!treeNode['isParent'] && ((treeNode['inner_ip'] && treeNode['inner_ip'].length !== 0) || (treeNode['public_ip'] && treeNode['public_ip'].length !== 0))) {
        this.isAlertShow = true
        this.alertHostName = treeNode.name
        this.alertInnerIp = treeNode.inner_ip
        this.alertPublicIp = treeNode.public_ip
        this.alertOs = treeNode.os
      } else {
        this.isAlertShow = false
        this.alertHostName = ''
        this.alertInnerIp = ''
        this.alertPublicIp = ''
        this.alertOs = ''
      }
      // let that = this
      // let sObj = $('#' + treeNode.tId + '_span')
      // if (treeNode.editNameFlag || $('#addBtn_' + treeNode.tId).length > 0) return
      // let addStr = "<span  id='addBtn_" + treeNode.tId + "' style='z-index: 1999;background-color: #555;text-align: left;padding: 2px;'  title='add node' onfocus='this.blur();'>" + '内网IP: ' + treeNode.inner_ip + '公网IP: ' + treeNode.public_ip + '</span>'
      // sObj.after(addStr)
    },
    removeHoverDom (treeId, treeNode) {
      $('#addBtn_' + treeNode.tId).unbind().remove()
    },
    showRemoveBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    showRenameBtn (treeId, treeNode) {
      return !treeNode.id === 0
    },
    beforeRemove (treeId, treeNode) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可删除'
        })
        return false
      }
      let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
      zTree.selectNode(treeNode)
      return confirm('确认删除「' + treeNode.name + '」分组吗？')
    },
    onRemove (e, treeId, treeNode) {
      deleteOpsCenterServerGroup(treeNode.id).then(res => {
        that.$Notice.success({
          title: '删除成功！'
        })
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '删除失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    beforeRename (treeId, treeNode, newName) {
      if (newName.length === 0) {
        that.$Notice.error({
          title: '节点名称不能为空'
        })
        return false
      }
      return true
    },
    beforeDrag (treeId, treeNodes) {
      return false
    },
    onRename (e, treeId, treeNode, isCancel) {
      if (treeNode.id === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      let reqData = { 'name': treeNode.name }
      changeOpsCenterServerGroup(reqData, treeNode.id).then(res => {
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerBtn () {
      let selectNodes = this.zTree.getSelectedNodes()
      if (selectNodes[0]['id'] === 0) {
        this.$Notice.error({
          title: '此分组不可编辑'
        })
        return false
      }
      this.hideRMenu()
      this.editServerModalTitle = '「' + selectNodes[0]['name'] + '」绑定主机'
      this.editServerModal = true
      this.editServerForm.id = selectNodes[0]['id']
      this.editServerForm.name = selectNodes[0]['name']
      this.editServerForm.server = selectNodes[0]['server_list']
      this.editServerForm.parent_id = selectNodes[0]['parent_id']
    },
    editServerForGroupSubmit () {
      let reqData = {
        id: this.editServerForm.id,
        name: this.editServerForm.name,
        server: this.editServerForm.server.join(','),
        parent_id: this.editServerForm.parent_id
      }
      changeOpsCenterServerGroup(reqData, this.editServerForm.id).then(res => {
        this.editServerModal = false
        this.editServerModalCancel()
        this.zNodes = [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
        this.getServerGroup()
        this.searchForm.id__in = ''
        this.getServers()
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    editServerModalCancel () {
      this.editServerForm.id = 0
      this.editServerForm.name = ''
      this.editServerForm.server = []
      this.editServerForm.parent_id = 0
    },
    editServerChange (newKeyList) {
      this.editServerForm.server = newKeyList
    },
    serverChangeModalClose () {
      this.serverChangeModal = false
      this.changeFormReset()
    },
    serverChangeModifyModalOpen () {
      if (this.selectRow) {
        this.serverForm.id = this.selectRow.id
        this.serverForm.hostname = this.selectRow.hostname
        this.serverForm.server_id = this.selectRow.server_id
        this.serverForm.name = this.selectRow.name
        this.serverForm.inner_ip = this.selectRow.inner_ip
        this.serverForm.public_ip = this.selectRow.public_ip
        this.serverForm.region = this.selectRow.region
        this.serverForm.os = this.selectRow.os
        if (this.selectRow.support) {
          this.serverForm.support = this.selectRow.support.id
        }
        if (this.selectRow.certificate) {
          this.serverForm.certificate = this.selectRow.certificate.map(item => item.id)
        }
        this.serverForm.server_info = this.selectRow.server_info
        this.serverForm.manager = this.selectRow.manager
        this.serverForm.remark = this.selectRow.remark
        this.serverChangeModalTitle = '编辑主机：' + this.selectRow.server_id
        this.serverChangeModal = true
      } else {
        this.$Notice.error({
          title: '请选择一台主机'
        })
      }
    },
    rowClick (data, index) {
      let oldStatus = this.tableData[index].checkBox
      this.tableData.forEach((items) => {
        this.$set(items, 'checkBox', false)
      })
      this.tableData[index].checkBox = !oldStatus
      if (this.tableData[index].checkBox) {
        this.selectRow = data
      } else {
        this.selectRow = ''
      }
    },
    serverRemove () {
      if (this.selectRow) {
        let that = this
        that.selectRow['is_delete'] = true
        that.$Modal.confirm({
          title: '删除',
          content: '确定要删除「' + that.selectRow.hostname + '」主机吗?',
          onOk: () => {
            that.selectRow.certificate = that.selectRow.certificate.map(item => item.id)
            changeOpsCenterServer(that.selectRow, that.selectRow.id).then(res => {
              that.$Notice.success({
                title: '删除成功！'
              })
              this.getServers()
            }).catch(res => {
              if (res.request) {
                that.$Notice.error({
                  title: '删除失败！请求状态码:' + res.request.status,
                  desc: res.request.responseText
                })
              }
            })
          }
        })
      } else {
        this.$Notice.error({
          title: '请选择一台主机'
        })
      }
    },
    getRegionList () {
      getRegion().then(res => {
        let result = res.data
        this.allRegionList = result.result
      })
    },
    supportChange (select) {
      let type = 4
      for (let i in this.allSupportList) {
        if (this.allSupportList[i].id === select) {
          type = this.allSupportList[i].type
          break
        }
      }
      this.regionList = []
      this.collectForm.region = ''
      if (type === 1) {
        this.regionList = this.allRegionList.aliyun_region_list
      } else if (type === 2) {
        this.regionList = this.allRegionList.ucloud_region_list
      } else if (type === 3) {
        this.regionList = this.allRegionList.aws_region_list
      }
    },
    collectSubmit () {
      this.collectServerLoading = true
      collectServer(this.collectForm).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.$Notice.success({
            title: '收集成功',
            desc: result.data
          })
          this.collectModal = false
          this.getServers()
        } else {
          this.$Notice.error({
            title: '收集失败！失败状态码:' + result.code,
            desc: result.msg
          })
        }
        this.collectServerLoading = false
      }).catch(res => {
        this.collectServerLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '收集失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getNowTime (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let hour = date.getHours() + ':'
      let minute = date.getMinutes() + ':'
      let second = date.getSeconds()
      let nowTime = year + '-' + month + '-' + day
      if (type !== 'date') {
        nowTime += ' ' + hour + minute + second
      }
      return nowTime
    },
    daysBetween (sDate1) {
      let time1 = Date.parse(new Date(sDate1))
      let time2 = Date.parse(new Date(this.getNowTime('date')))
      let nDays = parseInt((time1 - time2) / 1000 / 3600 / 24)
      if (time1 > time2) {
        return nDays
      } else {
        return -nDays
      }
    },
    connetRemoteAsset (ip, hostname) {
      // 调用后台创建 guacamole connect ，将返回id直接传到下面url中，连接远程机器，无需管 ops和 guacamole数据同步，目的是连接远程机器，权限在ops这边控制
      // let name = this.systemUsersSel
      let data = {
        ip: ip,
        username: this.systemUsersSel,
        key: this.systemUserKeySel,
        os: this.conHostOs,
        keyType: this.conProtocolType
      }
      getConnectId(data).then(res => {
        if (res.status === 200) {
          // console.log(res.data)
          let connectId = ClientIdentifier(parseInt(res.data))
          // console.log(connectId)
          // this.newId = connectId
          // window.location.href = 'http://opsdeep.aukeyit.com/guacamole/#/client/' + connectId
          // let url = 'http://10.1.2.127:8080/guacamole/#/client/' + connectId
          // this.url = guacamoleUrl + '/guacamole/#/client/' + connectId + '?token=' + this.guacamoleToken
          this.url = guacamoleUrl + '/guacamole/#/client/' + connectId
          // console.log(this.url)
          // let tabHost = {}
          // tabHost['name'] = ip
          // tabHost['url'] = this.url
          // tabHost['display'] = true
          // tabHost['hostname'] = hostname
          // tabHost['tabname'] = 'tab' + this.tabs.length.toString()
          // this.tabs.push(tabHost)
          // this.currentTab = tabHost['tabname']
          window.open(this.url, '_blank')
          // let h = window.screen.availHeight
          // let w = window.screen.availWidth
          // window.open(url, '堡垒机', 'left=0,top=0,width=' + w + ',height=' + h + ',directories=no,location=no,toolbar=no,menubar=no,status=no,scrollbars=no,titlebar=no,resizable=no')
        } else {
          this.$Message.error('获取连接信息失败，请核查数据')
        }
      })
    },
    // 远程连接
    handleConnect () {
      let selectNodes = this.zTree.getSelectedNodes()
      this.conHostOs = parseInt(selectNodes[0].os)
      let params = {
        host_id: selectNodes[0].host_id
      }
      getUserHostPerm(params).then(res => {
        let canCon
        this.userPermDetail = res.data.map(item => item['id'])
        let sysUsers = res.data.filter(item => item['id'] === selectNodes[0].host_id)
        if (this.$store.state.user.superuser) {
          if (this.userPermDetail.indexOf(selectNodes[0].host_id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '主机未绑定凭证',
              content: '该主机未绑定任何凭证，请先绑定凭证然后再连接 ！'
            })
          }
        } else {
          if (this.userPermDetail.indexOf(selectNodes[0].host_id) > -1) {
            canCon = true
          } else {
            canCon = false
            this.$Modal.error({
              title: '无操作权限',
              content: '您没有该主机的连接权限，请联系管理员开通 ！'
            })
          }
        }
        if (!canCon) {
        } else {
          // 弹出系统用户选择框
          if (sysUsers) {
            this.systemUsersAll = sysUsers.map(item => item['username'])
            this.systemUsersSel = this.systemUsersAll[0]
            this.systemUserKeySel = sysUsers.filter(item => item['username'] === this.systemUsersSel).map(item => item['key'])[0]
            this.conProtocolType = sysUsers.filter(item => item['username'] === this.systemUsersSel).map(item => item['type'])[0]
            // console.log(this.systemUserKeySel)
          } else {
            this.$Message.error('系统异常，取不到当前用户，当前主机所对应的系统用户，请检查权限数据')
          }
          // 判断公网ip 私有ip 给defaultIp 赋值
          if (selectNodes[0].public_ip || selectNodes[0].inner_ip) {
            this.defaultIp = selectNodes[0].public_ip ? 'public' : 'private'
            this.defaultSelIp = selectNodes[0].public_ip ? selectNodes[0].public_ip : selectNodes[0].inner_ip
          } else {
            this.$Message.error('系统异常，公有IP,私有IP都为空,请检查凭证ip数据')
            return
          }
          this.$Modal.confirm({
            width: '500px',
            title: '远程连接',
            onOk: () => {
              if (this.defaultSelIp) {
                this.connetRemoteAsset(this.defaultSelIp, selectNodes[0].name)
              } else {
                this.$Message.error('ip为空，不能建立连接,请检查凭证ip数据')
              }
            },
            render: (h) => {
              return h('div', [
                h('Divider'),
                h('span', { style: { color: '#515a6e' } }, '连接IP：'),
                h('RadioGroup', {
                  props: {
                    type: 'button',
                    value: this.defaultIp
                  },
                  style: { marginLeft: '58px' },
                  on: {
                    'on-change': (val) => {
                      if (val === 'private') {
                        this.defaultSelIp = ''
                        if (selectNodes[0].inner_ip) {
                          this.defaultSelIp = selectNodes[0].inner_ip
                        } else {
                          this.$Message.error('内部ip为空，不能建立连接')
                        }
                      } else {
                        this.defaultSelIp = ''
                        if (selectNodes[0].public_ip) {
                          this.defaultSelIp = selectNodes[0].public_ip
                        } else {
                          this.$Message.error('外部ip为空，不能建立连接')
                        }
                      }
                    }
                  }
                }, [
                  h('Radio', {
                    props: {
                      label: 'private'
                    } }, '内部IP'),
                  h('Radio', {
                    props: {
                      label: 'public'
                    } }, '外部IP')
                ]),
                h('br'),
                h('br'),
                h('span', { style: { color: '#515a6e' } }, '请选择凭证用户：'),
                h('Select', {
                  props: {
                    value: this.systemUsersSel
                  },
                  on: {
                    'on-change': (value) => {
                      this.systemUsersSel = value
                      this.systemUserKeySel = sysUsers.filter(item => item['username'] === this.systemUsersSel).map(item => item['key'])[0]
                      this.conProtocolType = sysUsers.filter(item => item['username'] === this.systemUsersSel).map(item => item['type'])[0]
                    }
                  },
                  style: {
                    width: '200px'
                  }
                },
                this.systemUsersAll.map(function (item) {
                  return h('Option', {
                    props: { value: item }
                  }, item)
                })
                ),
                h('Divider')
              ])
            }
          })
        }
      })
    }
  },
  mounted: function () {
    console.log('mounted')
    this.getServerGroup()
    // this.getGuacamoleToken()
  },
  created: function () {
    console.log('created')
  },
  destroyed () {
    // let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
    // zTree.refresh()
    console.log('destroyed')
  },
  activated () {
    console.log('activated')
    // let zTree = $.fn.zTree.getZTreeObj('serverGroupZTree')
    // zTree.destroy()
    this.getServerGroup()
  }
}
</script>

<style lang="less">
  @import '../../plugin/ztree/css/metroStyle/metroStyle.css';
  .demo-split{
      height: 100%;
      border: 1px solid #dcdee2;
  }
  .demo-split-pane{
      padding: 10px;
  }
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
  h1{
    margin: 0px;
  }
  html, body, #app {
    height: 100%;
    margin: 0px !important;
    padding: 0px !important;
    padding-top: 0;
    padding-left: 0;
    width: 100%;
  }
  .clients{
  }

  .managed-client{
    height: 260px;
    width: 450px;
  }

  .client #display div{
    margin: auto;
  }

@media screen and (max-width:1024px){
  .webTerminal{
    .demo-split{
      border:none;
    }
    .demo-split-pane{
      padding:0;
    }
    .ivu-split-pane{
      width:100%;
    }
    .left-pane{
      height: 80%;
      overflow-y: auto;
      background: #fff;
    }
    .right-pane{
      top: inherit;
      left:inherit!important;
      bottom: -12px;
    }
    .ivu-split-trigger-con{
      display:none;
    }
  }
}
@media screen and (max-width:320px){
  .webTerminal{
    .left-pane{
      height: 76%;
    }
  }
}

 @media screen and (min-width:768px) {
   .tree-style {
     .ivu-row {
       padding-left: 0!important;
       padding-top: 0!important;
       padding-bottom: 0!important;
     }
   }
 }

 .tree-style {
   .ztree * {
     font-size: 14px;
   }
   .ztree li span.button.ico_open,
   .ztree li span.button.ico_close,
   .ztree li span.button.ico_docu
   {
     display: none;
   }
   .ztree li span.button.root_close {
     background-position: -126px -65px;
   }
   .ztree li span.button.root_open {
     background-position: -105px -65px;
   }
   .ztree li span.button.center_close {
     background-position: -126px -23px;
   }
   .ztree li span.button.bottom_close {
     background-position: -126px -45px;
   }
   .ztree li span.button.bottom_open {
     background-position: -105px -45px;
   }
   .ztree li span.button.center_open {
     background-position: -105px -23px;
   }
   .ivu-col-span-1,
   .ivu-col-span-5 {
     padding-top: 16px;
     padding-bottom: 10px;
   }
   .ivu-col-span-5 {
     border-right: 6px solid #f5f7f9;
     margin-right: -6px;
     width: 18%;
   }
   .ivu-col-span-23 {
     padding-top: 16px!important;
   }
   .ztree li {
     line-height: 29px;
     ul {
       padding: 0;
       li {
         padding: 0 0 0 12px;
       }
     }
     a {
       height: 29px;
       width: 65%;
       span.button {
         margin-top: 7px;
       }
       &.curSelectedNode {
         background: none;
         color: #2d8cf0;
         span.button {
           display: none;
         }
         &:hover {
           span.button.add,
           span.button.edit,
           span.button.remove {
             display: inline-block;
           }
         }
       }
     }
   }
   .ztree li ul.line {
     background: none;
   }
   .ztree li span.button {
     background-image: url("../../assets/images/metro1.png");
   }
   .ztree li span.button.center_open {
     position: relative;
   }
   .ivu-col-span-19 {
     padding-top: 16px;
     padding-left: 20px;
     border-left: 6px solid #f5f7f9;
     width: 82%;
   }
   .left-pane {
     overflow-y: auto;
   }
 }

</style>
